<template>
  <base-section id="about-our-product">
    <base-section-heading
      color="grey lighten-2"
      icon="mdi-spider"
      title="타란툴라 소개"
    />

    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="4"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAboutOurProduct',

    data: () => ({
      cards: [
        {
          title: '독창적 아이디어 제품',
          subtitle: 'Creative Idea',
          text: '국내 유일의 이기종(동종) 데이터베이스 링크(DB LINK) 대체 솔루션입니다. 어쩌면 글로벌하게도 유일한 솔루션일지도 모릅니다. 타란툴라를 이용하면 데이터베이스 종류에 구애받지 않고 개발할수 있습니다.',
          callout: '01',
        },
        {
          title: '순수 국내 기술',
          subtitle: 'Technological competence',
          text: '"타란툴라"는 이기종 DB에 분산된 데이터를 실시간 조회 가능 솔루션으로서,  해외에 로열티를 지급하지 않는 순수 국내 기술로 제작된 미들웨어 제품입니다. 데이타베이스 종류에 상관없이 자유로이 데이터를 주고 받을수 있습니다.',
          callout: '02',
        },
        {
          title: 'GS 인증 1등급',
          subtitle: 'Best Quality',
          text: '"타란툴라"는, (주)오라스코프가 선보인 첫번째 GS 인증 1등급 제품 "OraScope.Net for Oracle" 에 이은, 두번째 GS인증 1등급 제품입니다. 장인 정신을 바탕으로 고객에게 만족과 신뢰를 드리는 우수한 품질의 솔루션을 제공합니다.',
          callout: '03',
        },
      ],
    }),
  }
</script>
